import {
	reResponsibilityTypesConstants
}from './constants'
import api from './api'
import {
	defAction
}from '../../../helpers/defaultAction'

export const reResponsibilityTypeActions = {
	getResponsibilityTypes,
	getResponsibilityTypeByName,
	getList,
	createResponsibilityType,
	deleteResponsibilityType,
	updateResponsibilityType,
	restoreResponsibilityType,
	clearResponsibilityType
}

function getResponsibilityTypes(params){
	return dispatch => {
		dispatch(request())

		api.getResponsibilityTypes(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_REQUEST
			}
		}
		function success(respTypes){
			return {
				type    : reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_SUCCESS,
				payload : respTypes
			}
		}
		function failure(error){
			return {
				type    : reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_FAILURE,
				payload : error
			}
		}
	}
}

function getResponsibilityTypeByName(params){
	return dispatch => {
		dispatch(request())

		api.getResponsibilityTypeByName(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_REQUEST
			}
		}
		function success(respTypes){
			return {
				type    : reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_SUCCESS,
				payload : respTypes
			}
		}
		function failure(error){
			return {
				type    : reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_FAILURE,
				payload : error
			}
		}
	}
}

function getList(params){
	const dispatchObj = {
		constants : reResponsibilityTypesConstants.getList,
		service   : {
			func   : api.getList,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createResponsibilityType(params){
	const dispatchObj = {
		constants : reResponsibilityTypesConstants.createReResponsibilityType,
		service   : {
			func   : api.createResponsibilityType,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function deleteResponsibilityType(params){
	const dispatchObj = {
		constants : reResponsibilityTypesConstants.deleteReResponsibilityType,
		service   : {
			func   : api.deleteResponsibilityType,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function updateResponsibilityType(params){
	const dispatchObj = {
		constants : reResponsibilityTypesConstants.updateReResponsibilityType,
		service   : {
			func   : api.updateResponsibilityType,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function restoreResponsibilityType(params){
	const dispatchObj = {
		constants : reResponsibilityTypesConstants.restoreReResponsibilityType,
		service   : {
			func   : api.restoreResponsibilityType,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearResponsibilityType(){
	return (dispatch) => dispatch({
		type: reResponsibilityTypesConstants.SEND_RERESPONSIBILITYTYPES_CLEAR
	})
}